<template>
  <div class="d-flex flex-column">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="limits"
      :filtersValue="filtersValue"
      :loading.sync="loading"
      :sort="sort"
      :hasMore.sync="hasMore"
    ></filtered-data>

    <div class="container-fluid">
      <div class="d-flex align-items-center justify-content-between">
        <h1 class="mr-3">Пороговые значения</h1>
        <button
          class="btn btn-outline-secondary btn-sm mr-auto"
          v-show="selected && selected.length"
          @click="editGroup()"
        >
          Редактировать выбранные
          <span class="badge badge-dark">{{ selected.length }}</span>
        </button>

        <btn-filters
          :data="data"
          endpoint="limits"
          v-model="filtersValue"
        ></btn-filters>
      </div>
    </div>

    <template v-if="data && data.data">
      <data-table-full-height
        :data="data.data"
        :hasMore="hasMore"
        :loading="loading"
        @load-more="$refs.data.loadMore"
        @sort-change="sortChange"
        @selection-change="(selection) => {this.selected = selection}"
        @row-click="(row) => edit(row)"
      >
        <table-column-serial-number sortable="keyword"/>
        <el-table-column align="center" type="selection"/>
        <table-column-number align="center" sortable="custom" prop="coins_tube_threshold"
                             label="Монет на тубу, шт."/>
        <table-column-number align="center" sortable="custom" prop="coins_tube_threshold_after_service"
                             label="Монет на тубу после сервиса, шт."/>
        <table-column-number align="center" sortable="custom" prop="coins_summary_threshold"
                             label="Сумма монет, руб."/>
        <table-column-number align="center" sortable="custom" prop="coins_summary_threshold_after_service"
                             label="Сумма монет после сервиса, руб."/>
        <table-column-number align="center" sortable="custom" prop="no_sales_time_threshold"
                             label="Простой без продаж, ч"/>
        <table-column-number align="center" sortable="custom" prop="no_banknote_time_threshold"
                             label="Простой без купюр, ч"/>
        <table-column-number align="center" sortable="custom" prop="no_coin_time_threshold"
                             label="Простой без монет, ч"/>
        <table-column-number align="center" sortable="custom" prop="banknotes_count_threshold"
                             label="Количество купюр, шт."/>
        <table-column-number align="center" sortable="custom" prop="temperature_low_threshold"
                             label="Низкая температура, C"/>
        <table-column-number align="center" sortable="custom" prop="temperature_high_threshold"
                             label="Высокая температура, C"/>
        <table-column-number align="center" sortable="custom" prop="service_interval_threshold"
                             label="Мин. период обслуж-я, дни"/>
      </data-table-full-height>
    </template>
  </div>
</template>

<script>
  import EditModal from '../../components/limits/edit-modal.vue'
  import isEqual from 'lodash/isEqual'

  export default {
    metaInfo: {title: 'Пороговые значения'},
    data() {
      return {
        filtersValue: null,
        data: {},
        loading: false,
        hasMore: true,
        moment: require('moment'),
        selected: [],
        sort: null,
      }
    },
    methods: {
      edit(machine) {
        this.$root.showModal(EditModal, {
          currentMachine: machine,
        })
      },
      editGroup(ids) {
        this.$root.showModal(EditModal, {
          ids: this.selected.map(o => o['id']),
          currentMachine: this.getLimitForSelected(),
        }).then((newLimit) => {
          newLimit && this.selected.forEach((machine) => {
            for (var key in newLimit) {
              machine[key] = newLimit[key]
            }
          })
        })
      },
      getLimitForSelected() {
        var limit = {
          banknotes_count_threshold: true,
          coins_tube_threshold: true,
          coins_tube_threshold_after_service: true,
          coins_summary_threshold: true,
          coins_summary_threshold_after_service: true,
          service_interval_threshold: true,
          no_sales_time_threshold: true,
          no_banknote_time_threshold: true,
          no_coin_time_threshold: true,
          temperature_low_threshold: true,
          temperature_high_threshold: true,
        }
        for (var i = 1; i < this.selected.length; i++) {
          for (var key in limit) {
            limit[key] = limit[key] && isEqual(this.selected[i][key], this.selected[i - 1][key])
          }
        }

        var sameLimit = {}
        for (var key in limit) {
          if (limit[key]) {
            sameLimit[key] = this.selected[0][key]
          }
        }
        return sameLimit
      },
      sortChange(sort) {
        if (sort.prop) {
          const order = sort.order === 'ascending' ? 'asc' : 'desc'
          const keyword = sort.column.sortable === 'keyword' ? '.keyword' : ''
          this.sort = `${sort.prop + keyword}:${order}`
        } else {
          this.$emit('update:sort', null)
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/admin/limits.vue